module.exports = __webpack_public_path__ + "static/CircularStd-Book-4f578bc504e38abf4fec7ad4bcaa6f73.woff";